import React from 'react';

const SortByContext = React.createContext();

const PageSizeContext = React.createContext();

// holds various content for search on a specific page:
// isMemberCompanySearch
// consist of variable to determine default search type and filter string
const SearchModeContext = React.createContext();

const ConfigFilterContext = React.createContext();

const AttendeeModeContext = React.createContext();

const SearchAPIKeyContext = React.createContext();

const SearchStateContext = React.createContext();

export {
    SortByContext,
    PageSizeContext,
    SearchModeContext,
    ConfigFilterContext,
    AttendeeModeContext,
    SearchAPIKeyContext,
    SearchStateContext,
};
